import React, { useRef, useState } from 'react';
import Dropdown from "../../elements/Dropdown.jsx";
import VerticalDots from "../../elements/VerticalDots.jsx";
import { onlineOnly } from "../../hooks/useOffline.js";

/**
 *
 * @param groceryListItem GroceryListItem
 * @param offline Deleting saves the list, which is online-only, so offline it is disabled.
 * @returns {JSX.Element}
 * @constructor
 */
export default function GroceryListItemEditDropdown({ groceryListItem, onChange, offline = false }) {

	const [hasIconRef, updateIconRef] = useState(false);
	const [dropdownOpened, updateDropdownOpened] = useState(false);

	if(!groceryListItem) {
		return null;
	}

	const clicked = () => {
		updateDropdownOpened(true);
	};

	const getIconRef = (theRef) => {
		updateIconRef(theRef);
	};

	const shouldRenderDropdown = false;
	const dropdownTargetName = `delete_grocery_list_item_dropdown_${groceryListItem.id}`;

	return (
		<div
			className='list_options'
		>
			<VerticalDots
				className='clickable'
				data-target={dropdownTargetName}
				onClick={clicked}
				ref={getIconRef}
			/>
			<Dropdown
				id={dropdownTargetName}
				opened={dropdownOpened}
				attachTo={hasIconRef}
				items={[
					{
						onClick: () => {
							onChange({ name: 'name', value: '', saveGroceryListUpdate: true });
						},
						content: <span>Delete {groceryListItem.name}</span>,
						...onlineOnly(offline),
					},
				]}
			/>
		</div>
	);
}
